import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { Dropdown, Menu, Input, Checkbox } from 'antd';
import { Icon, ThemeProvider } from 'dlweb-components'
import * as _ from 'lodash';

const QuickSearchBox = ({$location, $rootScope}) => {

  const inputEl = useRef(null);

  const [visible, setVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchOptions, setSearchOptions] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  const onChange = useCallback((e, option) => {

    let optionsCopy = searchOptions;
    _.find(optionsCopy, { id: option.id }).checked = e.target.checked;

    localStorage.searchOptions = JSON.stringify(optionsCopy);
    setSearchOptions([...optionsCopy])
  }, [searchOptions])

  useEffect(() => {

    const defaultOptions = [
      { id: 1, text: "Filename", checked: true },
      { id: 2, text: "Description", checked: false },
      { id: 3, text: "Version Notes", checked: false },
      { id: 4, text: "Property Values", checked: false },
      { id: 5, text: "Full Text", checked: true },
      { id: 6, text: "Workflow Comments", checked: false },
      { id: 7, text: "Use OR Operator", checked: true },
    ];

    let localOptions = localStorage.searchOptions && JSON.parse(localStorage.searchOptions);

    if (localOptions && localOptions.length === 7) {
      setSearchOptions(localOptions);
    } else {
      setSearchOptions(defaultOptions);
      localStorage.searchOptions = JSON.stringify(defaultOptions);
    }

  }, [])

  useEffect(() => {

    var items = [];

    searchOptions.forEach((option) => {
      items.push({
        key: option.id,
        label: (
          <Checkbox
            onChange={e => onChange(e, option)}
            checked={option.checked}
          >
            {option.text}
          </Checkbox>
        ),
      });
    })

    setMenuItems(items);

  }, [searchOptions, onChange])

  const handleVisibleChange = flag => {
    setVisible(flag)
  };

  const onSearch = (value) => {

    if(value === '') { return; }

    let stopListening = $rootScope.$on('$routeChangeSuccess', (e, data) => {
      if(data.originalPath !== '/search') {
        setSearchValue('');
        stopListening();
      }
    })

    const noOptions  = _.find(searchOptions, function(option) { return option.id < 7 && option.checked === true }) === undefined

    if (noOptions) {
      let optionsCopy = searchOptions;
      optionsCopy[0].checked = true;

      localStorage.searchOptions = JSON.stringify(optionsCopy);
      setSearchOptions([...optionsCopy]);
    }

    $location.url('/search').search(`q=${value}&page=1&nocache=${new Date().getTime()}`);
    $rootScope.$apply();
  }

  const buttonDropdown = (
    <>
      <SearchIconContainer
        onClick={() => onSearch(searchValue)}
      >
        <Icon type="search"/>
      </SearchIconContainer>
      <Dropdown
        menu={{
          items: menuItems
        }}
        trigger={['click']}
        placement="bottomRight"
        open={visible}
        onOpenChange={handleVisibleChange}
      >
        <DropdownIconContainer
          onClick={() => setVisible(!visible)}
        >
          <Icon type="chevron-down"/>
        </DropdownIconContainer>
      </Dropdown>
    </>

  )

  return (
    <ThemeProvider>
      <QuickSearchContainer>
        <Input
          placeholder="Search Documents"
          addonAfter={buttonDropdown}
          ref={inputEl}
          value={searchValue}
          onPressEnter={e => onSearch(e.target.value)}
          onChange={e => setSearchValue(e.target.value)}
        />
      </QuickSearchContainer>
    </ThemeProvider>

  )
}

const QuickSearchContainer = styled.div`
  height: 50px;
  width: 400px;
  line-height: 50px;
  padding: 9px 12px 0 0;
  text-transform: none;
  box-sizing: border-box;
  float: right;
  .ant-input-group-addon {
    background-color: #fff;
  }
`

const SearchIconContainer = styled.div`
  width: 100%;
  padding: 8px 11px;
  line-height: 28px;
  font-size: 10px;
  display: inline;
  cursor: pointer;
  color: #888;
  border-right: 1px solid #d9d9d9;
  &:hover {
    color: #000;
  }
`
const DropdownIconContainer = styled.div`
  width: 100%;
  padding: 8px 11px;
  line-height: 28px;
  font-size: 10px;
  display: inline;
`

export default QuickSearchBox;